

import { defineComponent } from 'vue';
import Button from 'primevue/button';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { showVuePopup } from '../utils/showVuePopup';
import Login from '../popup/Login.vue';
import ForgotPassword from '../popup/ForgotPassword.vue';
import Profile from '../popup/Profile.vue';
import WalletWithdraw from '../popup/WalletWithdraw.vue';
import AffiliateLink from '../popup/AffiliateLink.vue';
import AffiliateTransaction from '../popup/AffiliateTransaction.vue';
import AffiliateReport from '../popup/AffiliateReport.vue';
import AffiliateDownline from '../popup/AffiliateDownline.vue';
import PromotionList from '../popup/PromotionList.vue';
import PromotionBonus from '../popup/PromotionBonus.vue';
import PromotionCoupon from '../popup/PromotionCoupon.vue';
import PromotionSetting from '../popup/PromotionSetting.vue';
import ChangePassword from '../popup/ChangePassword.vue';
import Entertainment from '../popup/Entertainment.vue';
import Contact from '../popup/Contact.vue';
import Register from '../popup/Register.vue';

export default defineComponent({
	name: 'App',

	components: {
		Button,
	},

	setup() {
		const auth = useAuthStore();
		auth.hydrate();

		const { isLoggedIn } = storeToRefs(auth); // <<-- ดึง getter แบบ reactive

		return { auth, isLoggedIn };
	},

	computed: {
		loggedIn() {
			return this.isLoggedIn;
		},
	},

	methods: {
		btnClickRegister() {
			showVuePopup(Register, {}, {});
		},
		btnClickLogin() {
			showVuePopup(Login, {}, {});
		},
		btnClickForgotPassword() {
			showVuePopup(ForgotPassword, {}, {
				customClass: {
					htmlContainer: '',
				},
			});
		},
		btnClickProfile() {
			showVuePopup(Profile, {}, {});
		},
		btnClickWalletWithdraw() {
			showVuePopup(WalletWithdraw, {}, {});
		},
		btnClickAffiliateLink() {
			showVuePopup(AffiliateLink, {}, {});
		},
		btnClickAffiliateHistory() {
			showVuePopup(AffiliateTransaction, {}, {});
		},
		btnClickAffiliateReport() {
			showVuePopup(AffiliateReport, {}, {});
		},
		btnClickAffiliateDownline() {
			showVuePopup(AffiliateDownline, {}, {});
		},
		btnClickPromotionList() {
			showVuePopup(PromotionList, {}, {});
		},
		btnClickPromotionBonus() {
			showVuePopup(PromotionBonus, {}, {});
		},
		btnClickPromotionCoupon() {
			showVuePopup(PromotionCoupon, {}, {});
		},
		btnClickPromotionSetting() {
			showVuePopup(PromotionSetting, {}, {});
		},
		btnClickChangePassword() {
			showVuePopup(ChangePassword, {}, {});
		},
		btnClickLogout() {
			if (!confirm('ต้องการออกจากระบบ ใช่ หรือ ไม่?')) return;
			this.auth.logout();
			alert('ออกจากระบบแล้ว');
		},
		btnClickEntertainment() {
			showVuePopup(Entertainment, {}, {});
		},
		btnClickContact() {
			showVuePopup(Contact, {}, {});
		}
	},
});
